import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { Card } from './Card';
import { LazyImage, ImageContainer, ImageDummy } from './ImageContainer';
import washroomBefore from '../media/photos/bagno_b1.jpg';
import washroomAfter from '../media/photos/bagno_a1.jpg';
import showerBefore from '../media/photos/doccia_b1.jpg';
import showerAfter from '../media/photos/doccia_a1.jpg';
import windowsDoors1 from '../media/photos/infissi_e_porte_1.jpg';
import windowsDoors2 from '../media/photos/infissi_e_porte_2.jpg';
import windowsDoors3 from '../media/photos/infissi_e_porte_3.jpg';
import painting1 from '../media/photos/imbiancatura_1.jpeg';
import drywall2 from '../media/photos/su_misura_cartongesso_2.jpg';
import drywall3 from '../media/photos/cartongesso_isolamento_1.jpg';
import drywall4 from '../media/photos/cartongesso_isolamento_2.jpg';
import drywall5 from '../media/photos/cartongesso_isolamento_3.jpg';
import drywallOutsideBefore from '../media/photos/cartongesso_esterni_b.jpg';
import drywallOutsideAfter from '../media/photos/cartongesso_esterni_a.jpg';
import lights1 from '../media/photos/su_misura_illuminazione_1_cropped.jpg';
import lights2 from '../media/photos/su_misura_illuminazione_2.jpg';
import lights3 from '../media/photos/su_misura_illuminazione_3.jpg';
import lights4 from '../media/photos/su_misura_illuminazione_4.jpg';
import lights5 from '../media/photos/su_misura_illuminazione_5.jpg';
import lights6 from '../media/photos/su_misura_illuminazione_6.jpg';
import spaceRedimensioning1 from '../media/photos/su_misura_spazi_1.jpg';
import spaceRedimensioning2 from '../media/photos/su_misura_spazi_2.jpg';
import floor1 from '../media/photos/pavimento_1.jpg';
import floor2 from '../media/photos/pavimento_2_cropped.jpg';
import floor3 from '../media/photos/pavimento_3.jpg';
import { ReactComponent as Chiavi } from '../media/ristrutturazione_casa_chiavi.svg';
import { Layout } from './Layout';
import { FullBleedCard } from './FullBleedCard';

export function RenovationHome() {
    const { t } = useTranslation(namespaces.common);

    return (
      <>
        <FullBleedCard
          id={t("nav/home-renovation")}
          header={t("Ristrutturazione chiavi in mano")}
          title={t("Dalla progettazione alla realizzazione")}
          text={t("__Descrizione_casa__")}
          icon={<Chiavi />}
        />
        <Layout>
          <Card
            title={t("Bagni")}
            id={t("nav/bath")}
          >
            <ImageContainer>
              <LazyImage src={washroomBefore} alt="progetto-1" />
              <LazyImage src={washroomAfter} alt="progetto-1" />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={showerBefore} alt="progetto-2" />
              <LazyImage src={showerAfter} alt="progetto-2" />
            </ImageContainer>
          </Card>

          <Card
            title={t("Infissi e porte")}
            subtitle=""
            id={t("nav/doors")}
          >
            <ImageContainer>
              <LazyImage src={windowsDoors2} alt="infissi-e-porte-2" />
              <LazyImage src={windowsDoors3} alt="infissi-e-porte-3" />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={windowsDoors1} alt="infissi-e-porte-1" />
              <ImageDummy />
            </ImageContainer>
          </Card>

          <Card
            title={t("Imbiancatura lavabile")}
            subtitle=""
            id={t("nav/painting")}
          >
            <ImageContainer>
              <LazyImage src={painting1} alt="imbiancatura-lavabile-1" />
              <ImageDummy />
            </ImageContainer>
          </Card>

          <Card
            title={t("Soluzioni su misura")}
            subtitle={t("Apporto di muri in c/gesso ed illuminazione per ogni ambiente")}
            id={t("nav/drywall")}
          >
            <ImageContainer>
              <LazyImage src={lights3} alt="su-misura-5" />
              <LazyImage src={lights2} alt="su-misura-4" />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={lights6} alt="su-misura-8" />
              <LazyImage src={lights5} alt="su-misura-7" />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={lights1} alt="su-misura-3" />
              <LazyImage src={lights4} alt="su-misura-6" />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={drywall2} alt="su-misura-2" />
              <ImageDummy />
            </ImageContainer>
          </Card>

          <Card
            title={t("Soluzioni su misura")}
            subtitle={t("Ridimensionamento spazi")}
          >
            <ImageContainer>
              <LazyImage src={spaceRedimensioning1} alt="su-misura-9" />
              <ImageDummy />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={spaceRedimensioning2} alt="su-misura-10" />
              <ImageDummy />
            </ImageContainer>
          </Card>

          <Card
            title={t("Posa pavimenti")}
            subtitle=""
            id={t("nav/floor")}
          >
            <ImageContainer>
              <LazyImage src={floor1} alt="pavimento-1" />
              <LazyImage src={floor3} alt="pavimento-3" />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={floor2} alt="pavimento-2" />
              <ImageDummy />
            </ImageContainer>
          </Card>

          <Card
            title={t("Cartongesso per isolamento")}
            subtitle=""
          >
            <ImageContainer>
              <LazyImage src={drywall3} alt="cartongesso-isolamento-1" />
              <LazyImage src={drywall4} alt="cartongesso-isolamento-2" />
            </ImageContainer>

            <ImageContainer>
              <LazyImage src={drywall5} alt="cartongesso-isolamento-3" />
              <ImageDummy />
            </ImageContainer>
          </Card>

          <Card
            title={t("Cartongesso esterni")}
            subtitle={t("Prima e dopo")}
            id={t("nav/house")}
          >
            <ImageContainer>
              <LazyImage src={drywallOutsideBefore} alt="cartongesso-esterni-1" />
              <LazyImage src={drywallOutsideAfter} alt="cartongesso-esterni-2" />
            </ImageContainer>
          </Card>
        </Layout>
      </>
    )
}
